import { Loader, Logger } from '../sgvizler';
export class Dependency {
    constructor(url, loadBefore) {
        this.url = url;
        this.loadBefore = loadBefore ? loadBefore : null;
        this.endDownload = false;
        this.startDownload = false;
    }
    load() {
        if (!this.isLoaded()) {
            this.startDownload = true;
            Logger.logSimple('Load started :' + this.url);
            Loader.load(this);
        }
    }
    isLoaded() {
        if (Loader.isLoaded(this)) {
            this.startDownload = true;
            this.endDownload = true;
        }
        return this.endDownload;
    }
    callBack() {
        this.endDownload = true;
        Logger.logSimple('Load ended :' + this.url);
    }
}
export class ScriptDependency extends Dependency {
}
export class CssDependency extends Dependency {
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGVwZW5kZW5jeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZ3Zpemxlci9EZXBlbmRlbmN5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFDSCxNQUFNLEVBQ04sTUFBTSxFQUNULE1BQU0sYUFBYSxDQUFBO0FBRXBCLE1BQU0sT0FBZ0IsVUFBVTtJQU01QixZQUFhLEdBQVcsRUFBQyxVQUF1QjtRQUM1QyxJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQTtRQUNkLElBQUksQ0FBQyxVQUFVLEdBQUcsVUFBVSxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQTtRQUNoRCxJQUFJLENBQUMsV0FBVyxHQUFHLEtBQUssQ0FBQTtRQUN4QixJQUFJLENBQUMsYUFBYSxHQUFHLEtBQUssQ0FBQTtJQUM5QixDQUFDO0lBRU0sSUFBSTtRQUNQLElBQUksQ0FBRSxJQUFJLENBQUMsUUFBUSxFQUFFLEVBQUU7WUFDbkIsSUFBSSxDQUFDLGFBQWEsR0FBRyxJQUFJLENBQUE7WUFDekIsTUFBTSxDQUFDLFNBQVMsQ0FBQyxnQkFBZ0IsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUE7WUFDN0MsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQTtTQUNwQjtJQUNMLENBQUM7SUFFTSxRQUFRO1FBQ1gsSUFBSSxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxFQUFFO1lBQ3ZCLElBQUksQ0FBQyxhQUFhLEdBQUcsSUFBSSxDQUFBO1lBQ3pCLElBQUksQ0FBQyxXQUFXLEdBQUcsSUFBSSxDQUFBO1NBQzFCO1FBQ0QsT0FBTyxJQUFJLENBQUMsV0FBVyxDQUFBO0lBQzNCLENBQUM7SUFFTSxRQUFRO1FBQ1gsSUFBSSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUE7UUFDdkIsTUFBTSxDQUFDLFNBQVMsQ0FBQyxjQUFjLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQy9DLENBQUM7Q0FDSjtBQUVELE1BQU0sT0FBTyxnQkFBaUIsU0FBUSxVQUFVO0NBQUc7QUFFbkQsTUFBTSxPQUFPLGFBQWMsU0FBUSxVQUFVO0NBQUcifQ==